import { configureStore } from '@reduxjs/toolkit';
import { contextStateRedux } from '../redux/application/contextStateRedux';

export default configureStore({
  reducer: { contextState: contextStateRedux.reducer },
  devTools:
    process.env.REACT_APP_ENV !== 'production' ||
    process.env.REACT_APP_ENV !== 'live',
});
